import styled from 'styled-components';

export const AboutWrapper = styled.div`
  width: 100%;
  height: 100%;
  .aboutContent {
    position: relative;
    height: 100%;
    overflow: auto;
    .--img {
      width: 100%;
      position: relative;
      margin-bottom: 1rem;
      border-radius: 12px 12px 0 0;
      overflow: hidden;
      img {
        width: 100%;
        height: 440px;
        object-fit: cover;
        object-position: bottom;
      }
    }
    .--title {
      color: #fff;
      font-weight: 700;
      padding: 0 3rem;
      font-size: 3rem;
      text-shadow: 0 1px 32px #000;
      position: absolute;
      bottom: 2rem;
    }
    .--content {
      border-radius: 12px;
      background: #f9f2e5;
      /* height: 100%; */
      /* overflow: auto; */
      max-width: 640px;
      width: 64%;
      margin: 0 auto;
      /* border: 1px solid #ddd; */
      position: relative;
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background: #f1f1f1;
      }
      article {
        font-size: 14px;
        padding: 0 3rem;

        h2 {
          font-size: 1.5rem;
          font-weight: 700;
        }
        p {
          margin-bottom: 1rem;
        }
        a {
          color: var(--color-1);
          &:hover {
            text-decoration: underline;
          }
        }
        ul {
          padding-left: 1rem;
        }
      }
    }
    @media (max-width: 640px) {
      height: 100%;
      .--content {
        width: 100%;
        article {
          padding: 0 1.5rem;
        }
      }
      .--img {
        img {
          height: auto;
        }
      }
      .--title {
        font-size: 2.5rem;
        padding: 0 1.5rem;
      }
    }
  }
`;
